import React from 'react';

import { useTranslation } from 'client/hooks';

import Icon from '../../../../Icon';

import css from './MicrophoneButton.module.scss';

interface Props {
  isMicMuted: boolean;
  isBroadcasting: boolean;
  isRoomFinished?: boolean;
}

const MicrophoneButton: React.FC<Props> = (props) => {
  const { isMicMuted, isBroadcasting, isRoomFinished = false } = props;
  const { translate } = useTranslation('actionsPanel');

  return (
    <>
      <div className={css.iconWrapper}>
        {(isBroadcasting || isRoomFinished) && (
          <Icon
            color={isRoomFinished ? '#999999' : ''}
            type={isMicMuted ? 'mic-muted-l' : 'mic-unmute-l'}
            className={css.micIcon}
          />
        )}
        {!isRoomFinished && !isBroadcasting && (
          <Icon
            color={isRoomFinished ? '#999999' : ''}
            type={!isMicMuted ? 'black_microphone' : 'forbidden_microphone'}
            className={css.micInactive}
          />
        )}
      </div>
      <div className={css.name}>
        {isMicMuted ? translate('btns.hostMicMutedBtn') : translate('btns.hostMicUnmutedBtn')}
      </div>
    </>
  );
};

export default MicrophoneButton;
